import { combineActions, handleActions } from 'redux-actions'
import { leaveContent } from '@tabeeb/modules/shared/content/actions'
import { closeAiReportDialog, openAiReportDialog } from '../actions'

const defaultState = false

export default handleActions(
  {
    [openAiReportDialog]() {
      return true
    },
    [combineActions(closeAiReportDialog, leaveContent)]() {
      return false
    },
  },
  defaultState
)
